// DevHub (#92/#103): Detect the TechDocs document currently being read.
//
// The doc reader is mounted at /docs/:namespace/:kind/:name/* (see App.tsx). When
// the user is on such a route we can scope search to that entity's TechDocs pages
// — the "search within the current document" affordance — by filtering the
// techdocs search collator on the entity's { namespace, kind, name }, which it
// indexes for every doc page.

import { useLocation } from 'react-router-dom';

export interface CurrentDoc {
  namespace: string;
  kind: string;
  name: string;
}

/**
 * Returns the entity coordinates of the doc being read, or null when the current
 * route is not a TechDocs reader page.
 */
export function useCurrentDoc(): CurrentDoc | null {
  const { pathname } = useLocation();

  // Match /docs/:namespace/:kind/:name (with optional trailing sub-path).
  const match = pathname.match(/^\/docs\/([^/]+)\/([^/]+)\/([^/]+)/);
  if (!match) return null;

  const [, namespace, kind, name] = match;
  // Guard against the docs LANDING pages (/docs, /docs-overview, /docs-curated,
  // /docs-index) — those have fewer than three path segments after /docs and so
  // won't match the regex above, but be explicit about the reader-only intent.
  if (!namespace || !kind || !name) return null;

  return { namespace, kind: kind.toLowerCase(), name };
}
